export default "__VITE_ASSET__DmuT1fy7__"